import React from 'react'

const IconExpand = ({ variant = 'primary' }) => {
  return (
    <>
      {variant === 'primary' && (
        <svg
          width='17'
          height='16'
          viewBox='0 0 17 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M10.8668 2H14.8668V6H13.5334V3.33333H10.8668V2ZM1.53343 2H5.53343V3.33333H2.86677V6H1.53343V2ZM13.5334 12.6667V10H14.8668V14H10.8668V12.6667H13.5334ZM2.86677 12.6667H5.53343V14H1.53343V10H2.86677V12.6667Z'
            fill='#6F6F6F'
          />
        </svg>
      )}

      {variant === 'secondary' && (
        <svg
          width='20'
          height='20'
          viewBox='0 0 20 20'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          {/* <mask id="mask0_16656_433218" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask> */}
          {/* <g mask="url(#mask0_16656_433218)"> */}
          <path
            d='M11.7077 13.291H15.291V9.70768H14.2077V12.2077H11.7077V13.291ZM4.70768 10.291H5.79102V7.79102H8.29102V6.70768H4.70768V10.291ZM2.41602 15.5827V4.41602H17.5827V15.5827H2.41602ZM3.49935 14.4993H16.4993V5.49935H3.49935V14.4993Z'
            fill='#686867'
          />
          {/* </g> */}
        </svg>
      )}
    </>
  )
}

export default IconExpand
